import React, { useState, useRef, useEffect } from 'react';

export type FilterType = 'IN' | 'OUT' | 'REFUND';

interface TransactionFilterProps {
  currentFilters: FilterType[];
  onFilterChange: (filters: FilterType[]) => void;
}

const TransactionFilter: React.FC<TransactionFilterProps> = ({ currentFilters, onFilterChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const options: { value: FilterType; label: string }[] = [
    { value: 'IN', label: 'In' },
    { value: 'OUT', label: 'Out' },
    { value: 'REFUND', label: 'Refunds' }
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleFilter = (val: FilterType) => {
    if (currentFilters.includes(val)) {
      onFilterChange(currentFilters.filter(f => f !== val));
    } else {
      onFilterChange([...currentFilters, val]);
    }
  };

  return (
    <div className="transaction-filter-container" ref={menuRef}>
      <button 
        className={`transaction-filter-btn ${currentFilters.length > 0 ? 'has-active' : ''}`} 
        onClick={() => setIsOpen(!isOpen)} 
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
        {currentFilters.length > 0 && <span className="transaction-filter-badge">{currentFilters.length}</span>}
      </button>
      <span className="payouts-tip transaction-filter-tip-custom">Filter transactions</span>
      <div className={`transaction-filter-menu ${isOpen ? 'menu-open' : ''}`}>
        <div className="transaction-filter-menu-header">Filter by</div>
        {options.map(opt => {
          const isActive = currentFilters.includes(opt.value);
          return (
            <div 
              key={opt.value} 
              className="transaction-filter-item"
              onClick={() => toggleFilter(opt.value)}
            >
              <div className={`transaction-filter-checkbox ${isActive ? 'checked' : ''}`}>
                {isActive && (
                  <svg width="10" height="8" viewBox="0 0 12 10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg>
                )}
              </div>
              {opt.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransactionFilter;
